








































































import { BaseStepForm } from '@/components/forms/onboarding/BaseStepForm';
import { IODCatchmentAreaForm } from '@/model';
import { Nullable } from '@homeserve/od-typings/utils';
import { IDepartment, IRegion } from '@homeserve/vue-api-plugin';
import flatten from 'lodash/flatten';
import { Component, Emit, Watch } from 'vue-property-decorator';
import { State } from 'vuex-class';

interface ISelectableDepartment extends IDepartment {
  selected: boolean;
}

@Component
export default class CatchmentAreaForm extends BaseStepForm<IODCatchmentAreaForm> {
  @State(state => state.api.trader.region.regions.filter(region => region.code !== 94))
  public regions!: IRegion[];

  public departments: ISelectableDepartment[] = [];
  public readonly formScope = 'catchmentAreaForm';
  public selectedRegion: Nullable<IRegion> = null;

  public get filteredDepartments(): ISelectableDepartment[] {
    if (!this.selectedRegion) {
      return [];
    }

    const departmentsCode = this.selectedRegion.departments.map(department => department.departmentCode);

    return this.departments.filter(department => departmentsCode.indexOf(department.departmentCode) !== -1);
  }

  public get hasSelectedDepartments(): boolean {
    return this.departments.filter(department => department.selected).length > 0;
  }

  public async created() {
    await this.attachValidatorFields();

    this.departments = flatten(this.regions.map(region => region.departments)).map(department => ({
      ...department,
      selected: this.model.departments.indexOf(department.departmentCode) !== -1,
    }));
  }

  private async attachValidatorFields() {
    const validate = Object.keys(this.$validator.errors.collect(undefined, this.formScope)).length > 0;

    if (this.$validator.fields.find({ name: 'departments', scope: this.formScope })) {
      this.$validator.detach('departments', this.formScope);
    }

    this.$validator.attach({
      getter: () => this.model.departments,
      name: 'departments',
      rules: 'required',
      scope: this.formScope,
    });

    if (validate) {
      await this.isValid();
    }
  }

  @Emit('change')
  @Watch('departments', { deep: true })
  private onDepartmentsChanged(departments) {
    return {
      ...this.model,
      departments: [
        ...departments
          .filter(department => department.selected)
          .map(department => department.departmentCode)
          .sort(),
      ],
    };
  }

  @Watch('model.departments')
  private async onWorkingPostCodesChanged() {
    await this.$validator.validate(`${this.formScope}.departments`);
  }
}
